import BaseScene from './BaseScene';
import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';

export default class SettingName extends BaseScene {

    private userName = '';
    private inputUserName: any = null;

    constructor() {
        super({key: 'SettingName'});
    }

    public init() {
        super.init();
        this.userName = this.getBootloaderScene().AppData.user.name;  
    }

    public preload() {
        this.load.html('inputForm', 'assets/html/form.html');
    }

    public create() {
        super.create();

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);

        // Panel
        const panel = this.add.image(0, 0,'game_panel_about').setScale(1.2, 1);

        const text = translate.key('setting_name_1');

        const aboutText = this.add.text(-10, -110, text)
            .setOrigin(0.5)
            .setWordWrapWidth(300)
            .setStyle({ 
                fontFamily: 'supersonic',
                fontSize: 26,
                color: '#3d3d3d',
                align: 'center',
            });

        const userNameDescription = this.add.text(-10, 20,translate.key('settings_text_3'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 26,
                color: '#3d3d3d'
            });

        const playButton = new ButtonSprite(this, -10, 222, 'button_next', 2, () => this.playGame())
            .setScale(0.9)
            .setVisible(false);

        const container = this.add.container((this.width / 2) + 25, -300).add([panel, aboutText, userNameDescription, playButton]);

        // Form
        const form = this.add.dom((this.width / 2) -120 , -280)
            .setOrigin(0)
            .createFromCache('inputForm');
        this.inputUserName = form.getChildByName('user-name');
        this.inputUserName.placeholder = translate.key('settings_text_5');
        if (this.inputUserName) {
            this.inputUserName.value = this.userName;
        }
        this.inputUserName.addEventListener('input', () => {
            console.log(this.inputUserName.value.trim().length);
            playButton.setVisible(this.inputUserName.value.trim().length > 0);
        });
        this.inputUserName.addEventListener('keydown', (event: any) => {
            if (event.key === 'Enter') {
                this.inputUserName.blur();
            }
        });
        document.addEventListener('click', (event) => {
            if (!this.inputUserName.contains(event.target)) {
                this.inputUserName.blur();
            }
        });

        // Tweens
        this.tweens.add({
            y: 460,
            targets: [container],
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });
        this.tweens.add({
            y: 494,
            targets: [form],
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });
    }

    private playGame() {
        if(this.bootloaderScene) {
            this.getBootloaderScene().setUserName(this.inputUserName.value);
            this.getBootloaderScene().stopScene('SettingName');
            this.bootloaderScene.launchScene('LevelSelector');
        }
    }
}
